import { render } from "./index.vue?vue&type=template&id=6f941ec5&scoped=true&bindings={}"
import script from "./album-table.js?vue&type=script&lang=js"
export * from "./album-table.js?vue&type=script&lang=js"

import "./album-table.scss?vue&type=style&index=0&id=6f941ec5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6f941ec5"

export default script